export default function TechnologyGrid() {
  const technologies = [
    {
      category: 'Networking',
      items: [
        { name: 'Ubiquiti UniFi', icon: 'ri-wifi-line' },
        { name: 'Cisco Meraki', icon: 'ri-router-line' },
        { name: 'Fiber Optic', icon: 'ri-flashlight-line' },
        { name: 'Cat6A/Cat7', icon: 'ri-plug-line' }
      ]
    },
    {
      category: 'Security',
      items: [
        { name: 'Hikvision', icon: 'ri-camera-line' },
        { name: 'Axis Communications', icon: 'ri-vidicon-line' },
        { name: 'Alarm.com', icon: 'ri-alarm-warning-line' },
        { name: 'Access Control', icon: 'ri-door-lock-line' }
      ]
    },
    {
      category: 'Audio/Video',
      items: [
        { name: 'Sonos', icon: 'ri-speaker-line' },
        { name: 'Sony 4K/8K', icon: 'ri-tv-line' },
        { name: 'Dolby Atmos', icon: 'ri-surround-sound-line' },
        { name: 'Lutron Shades', icon: 'ri-contrast-drop-line' }
      ]
    },
    {
      category: 'Lighting',
      items: [
        { name: 'Lutron', icon: 'ri-lightbulb-line' },
        { name: 'Philips Hue', icon: 'ri-lightbulb-flash-line' },
        { name: 'DMX Control', icon: 'ri-palette-line' },
        { name: 'Ketra', icon: 'ri-sun-line' }
      ]
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[11px] tracking-[0.3em] uppercase text-[#4A90E2] mb-4 font-light">
            TECHNOLOGY PARTNERS
          </p>
          <h2 className="text-5xl font-serif text-gray-900 mb-6">
            <strong>Industry-Leading Brands</strong>
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We partner with the world's most trusted manufacturers to deliver reliable, high-performance <strong>smart home solutions</strong>
          </p>
        </div>

        {/* Technology Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {technologies.map((tech, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 border border-gray-200 hover:border-[#4A90E2]/30 hover:shadow-lg transition-all">
              <h3 className="text-lg font-semibold text-gray-900 mb-6 pb-4 border-b border-gray-200">
                {tech.category}
              </h3>
              <ul className="space-y-4">
                {tech.items.map((item, idx) => (
                  <li key={idx} className="flex items-center gap-3 group cursor-pointer">
                    <div className="w-10 h-10 rounded-lg bg-[#4A90E2]/10 flex items-center justify-center group-hover:bg-[#4A90E2] transition-colors flex-shrink-0">
                      <i className={`${item.icon} text-[#4A90E2] group-hover:text-white text-lg transition-colors`}></i>
                    </div>
                    <span className="text-sm text-gray-700 group-hover:text-[#4A90E2] transition-colors">
                      {item.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-16 text-center">
          <p className="text-sm text-gray-600 mb-6">
            And many more industry-leading brands and technologies
          </p>
          <a
            href="#platforms"
            className="inline-flex items-center gap-2 text-sm font-medium text-[#4A90E2] hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
          >
            View All Platforms
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
